<template>
    <div v-show='product.product'>
        <AddToCart class='spaced' :class="{'add-to-cart':product.typeid != '1'}" :variant_code='variant_code' :product='product' :in_stock='in_stock' @updatedCartListener='updatedCartListener'/>
        <!-- <div v-if="product.typeid == 1">  -->
            <TextSeparator class='spaced' />
            <LockItInButtons :variant_code='variant_code' :product='product' :in_stock='in_stock' @updatedCartListener='updatedCartListener'/>
        <!-- </div> -->
    </div>
</template>
<script>
import AddToCart from '@/ecom/components/products/single_product/details/AddToCart.vue';
import ProductButtonsPlaceholders from '@/ecom/components/products/single_product/details/ProductButtonsPlaceholders.vue';
import TextSeparator from '@/ecom/components/separators/TextSeparator.vue';
import LockItInButtons from '@/ecom/components/products/single_product/details/LockItInButtons.vue';

export default {
    components: {AddToCart, ProductButtonsPlaceholders, TextSeparator, LockItInButtons},
    emits: ['updatedCartListener'],
    props: ['product', 'variant_code', 'in_stock'],
    methods:{
        updatedCartListener(){
            this.$emit('updatedCartListener');
        }
    }
}
</script>
<style lang="scss" scoped>
.add-to-cart{
    margin-top: 30px;
}
.spaced{
    margin-bottom: 20px;
}
</style>